export function announcementBanner() {
    const announcementBanner = $(".announcement-banner");
    if (sessionStorage.getItem("show-hide")) {
        announcementBanner.css("display", sessionStorage.getItem("show-hide"));
    }

    announcementBanner.find(".close").on("click", function () {
        announcementBanner.hide();
        sessionStorage.setItem("show-hide", announcementBanner.css("display"));
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/announcementBanner.js